import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isVisible", "isLoading", "type", "title", "children", "onClose"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import styled, { css } from 'styled-components';
import { pxToRem, hasReactChildren } from 'utils/ui';
import { spacing } from 'styles/globals';
import ThemeSection from 'components/ThemeSection';
import Button from 'components/Button';
import { alertTypeMap } from 'components/Alert';
import { SpinnerDot } from 'components/icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isVisible';
  }
}).withConfig({
  displayName: "AlertBox__Wrapper",
  componentId: "sc-13f9pyu-0"
})(["position:relative;max-width:", ";padding:", ";padding-right:", ";color:", ";background-color:", ";box-shadow:0 0 ", " rgba(0,0,0,0.25);visibility:hidden;opacity:0;transition:visibility 0s linear 0.35s,opacity 0.35s ease-in;", " & + &{margin-top:", ";}"], pxToRem(320), spacing.s, spacing.xl, function (p) {
  return p.theme.text;
}, function (p) {
  return p.theme.background;
}, spacing.s, function (p) {
  return p.isVisible && css(["visibility:visible;opacity:1;transition-delay:0s;transition-timing-function:ease-out;"]);
}, spacing.m);
var Title = styled.h3.withConfig({
  displayName: "AlertBox__Title",
  componentId: "sc-13f9pyu-1"
})(["display:block;word-wrap:break-word;font-weight:600;line-height:1;text-transform:uppercase;"]);
var Message = styled.p.withConfig({
  displayName: "AlertBox__Message",
  componentId: "sc-13f9pyu-2"
})(["line-height:1.1;word-wrap:break-word;margin-top:", ";"], spacing.xxs);
var AlertBox = function AlertBox(_ref) {
  var _ref$isVisible = _ref.isVisible,
    isVisible = _ref$isVisible === void 0 ? true : _ref$isVisible,
    isLoading = _ref.isLoading,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'fail' : _ref$type,
    title = _ref.title,
    children = _ref.children,
    onClose = _ref.onClose,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var hasChildren = hasReactChildren(children);
  return /*#__PURE__*/_jsx(ThemeSection, {
    name: alertTypeMap[type] || type,
    children: /*#__PURE__*/_jsxs(Wrapper, _objectSpread(_objectSpread({
      isVisible: isVisible
    }, otherProps), {}, {
      children: [/*#__PURE__*/_jsxs(Title, {
        id: "alert_box_title",
        children: [title, isLoading && /*#__PURE__*/_jsx(SpinnerDot, {
          vAlign: true,
          ml: "xs"
        })]
      }), hasChildren && /*#__PURE__*/_jsx(Message, {
        id: "alert_box_text",
        children: children
      }), /*#__PURE__*/_jsx(Button, {
        position: "absolute",
        right: "xxs",
        top: 6,
        size: "medium",
        icon: "x",
        variant: "transparent",
        onClick: onClose
      })]
    }))
  });
};
export default AlertBox;